import styled from 'styled-components';

export const StyledTbmDetailModal = styled.div`
  padding: 16px;

  .meta {
    font-size: 15px;
    font-weight: 600;
    color: #2f2f35;
  }

  .tbmAttendance {
    display: flex;
    flex-direction: column;
    gap: 16px;

    &-name {
      display: flex;
      align-items: center;
      gap: 8px;

      img {
        width: 24px;
        height: 24px;
        border-radius: 50%;
      }
    }
  }

  h2 {
    color: #b99c5d;
    font-family: Poppins;
    font-size: 16px;
    font-weight: 600;
    line-height: 24px;
    text-align: left;
    margin-top: 27px;

    margin-bottom: 12px;
    position: relative;
    margin-left: 8px;
    padding-left: 16px;

    &::before {
      content: '';
      position: absolute;
      top: 50%;
      left: 0%;
      width: 12px;
      height: 12px;
      border-radius: 50%;
      background-color: transparent;
      border: 2px solid #b99c5d;
      transform: translate(-50%, -50%);
    }
  }

  .form-wrapper {
    margin-left: 0 !important;
    border-top: 1px solid #dadada;
    position: relative;

    &-label {
      width: 232px;
      padding: 9px 12px !important;
      font-weight: 500;

      color: #222;
      background-color: #f8f8f8;
      white-space: nowrap;
      border-top: 1px solid #dadada;
      border-bottom: 1px solid #dadada;
      display: flex;
      align-items: center;

      p {
        font-family: Poppins;
        font-size: 14px;
        font-weight: 500;
        line-height: 18px;
        text-align: left;
      }

      &:nth-of-type(odd) {
        border-top: 0;
      }

      &:last-child {
        border-bottom: 0 !important;
      }
    }

    &-body {
      padding: 4px !important;
      /* max-width: 100% !important; */
      width: calc(100% - 232px);
      display: flex;
      align-items: center;
      border-bottom: 1px solid #dadada;

      p {
        font-family: Poppins;
        font-size: 14px;
        font-weight: 400;
        line-height: 18px;
        text-align: left;
        background: #f8f8f8;
        border: 0.5px solid #dadada;
        width: 100%;
        padding: 5px 10px;

        img {
          min-height: 388px !important;
          max-height: 388px !important;
          object-fit: contain;
        }

        .noContent {
          min-height: 388px !important;
          max-height: 388px !important;
        }
      }
    }

    .cold-sub-title {
      color: #b99c5d;
      font-weight: 600;
      font-size: 16px;
      margin-bottom: 12px;
      position: relative;
      margin-left: 8px;
      padding-left: 16px;

      &::before {
        content: '';
        position: absolute;
        top: 50%;
        left: 0%;
        width: 12px;
        height: 12px;
        border-radius: 50%;
        background-color: transparent;
        border: 2px solid #b99c5d;
        transform: translate(-50%, -50%);
      }
    }

    .MuiSelect-select {
      height: 28px !important;
      line-height: 28px !important;
      padding: 0 !important;
      padding-left: 12px;
    }

    .search-btn {
      width: 130px !important;
      border: none !important;
      color: transparent;
      background-color: #fff;
      border-radius: 0 !important;
      height: 30px;
      box-shadow: none !important;
      padding: 0 !important;
      border: 1px solid #dadada !important;
      color: #dadada !important;

      .MuiButton-endIcon {
        width: 100%;
        display: flex;
        justify-content: flex-end;
        margin-right: 5px;
      }

      > span {
        padding-left: 10px;
      }

      &-icon {
        width: 24px;
        height: 24px;
      }
    }

    .MuiButtonBase-root {
      height: 28px !important;
      border-radius: 0 !important;
      box-shadow: 0 !important;
    }

    .form-center {
      display: flex;
      align-items: center;

      &.gap-10 {
        gap: 10px;
      }

      &.gap-28 {
        gap: 28px;
        margin-left: 12px !important;
      }

      &.input {
        gap: 5px;

        .basic-input {
          width: 100% !important;
        }
      }
    }

    &-top {
      margin: 24px 0;
      position: relative;
      > h2 {
        color: #b99c5d;
        font-weight: 600;
        font-size: 16px;
        margin-bottom: 12px;
        position: relative;
        margin-left: 8px;
        padding-left: 16px;

        &::before {
          content: '';
          position: absolute;
          top: 50%;
          left: 0%;
          width: 12px;
          height: 12px;
          border-radius: 50%;
          background-color: transparent;
          border: 2px solid #b99c5d;
          transform: translate(-50%, -50%);
        }
      }

      &-box {
        margin-left: 0 !important;
        /* border-top: 1px solid #dadada; */

        &-label {
          padding: 9px 12px !important;
          font-weight: 500;
          color: #222;
          background-color: #f8f8f8;
          white-space: nowrap;
          border-top: 1px solid #dadada;
          border-bottom: 1px solid #dadada;

          font-family: Poppins;
          font-size: 14px;
          font-weight: 500;
          line-height: 18px;
          text-align: left;

          &:nth-of-type(odd) {
            border-top: 0;
          }

          &:last-child {
            border-bottom: 0 !important;
          }
        }

        &-content {
          padding: 4px !important;
          max-width: 100% !important;
          width: 100%;
          display: flex;
          align-items: center;
          /* border-bottom: 1px solid #dadada; */

          > div {
            width: 100%;

            &.MuiFormControl-root {
              width: initial;
            }
          }

          &.height {
            > div {
              height: 100%;
              display: flex;
              align-items: center;

              > div {
                height: 90%;

                > input {
                  height: 90%;

                  &:disabled {
                    color: #000 !important;
                    -webkit-text-fill-color: #000 !important;
                  }
                }
              }
            }
          }

          &-equipment {
            display: flex;
            flex-direction: column;

            &-row {
              display: flex;
              justify-content: space-between;
              align-items: center;
              height: 70px;
              &-select {
                /* height: 100%; */
              }

              &-amount {
                height: 100%;
                display: flex;
                align-items: center;
              }
            }

            &-btn {
              display: flex;
              align-items: center;
              gap: 12px;

              .MuiButtonBase-root {
                height: 20px;
                padding: 8px 16px;
                border-radius: 6px;
                background-color: #b99c5d;
                color: #fff;
                font-size: 14px;
                font-weight: 500;
              }
            }
          }
        }
      }
    }
  }
`;
